import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { classNames } from 'util/utils';

import { ReactComponent as LoaderSvg } from 'assets/svg/loader.svg';

function CircularProgress({ className, message, loader, visible, ...props }) {
  return !loader && !visible ? (
    <div className={classNames([`loader`, className])} {...props}>
      {message ? <span>{message}</span> : <LoaderSvg />}
    </div>
  ) : null;
}

CircularProgress.propTypes = {
  message: PropTypes.node,
};

export default connect(
  ({ loader }) => ({
    loader: Boolean(loader?.loading),
    visible: Boolean(loader?.visible),
  }),
  {},
)(React.memo(CircularProgress));
